import React from 'react'
import { Row, Col } from '@cx/couturier/Grid'
import styled, { css } from 'styled-components'
import { Footer } from '@cx/couturier/labs/ImmersiveFlow'

const FooterRowMobile = styled(Row)`
  && {
    display: none;
    ${({ theme: { media } }) =>
      media.smallMedium(css`
        display: block;
        /* margin-top: 3rem; */
        margin-top: 25vh;

        position: absolute;

        max-width: 18rem;
        padding-bottom: 4rem;
      `)}
  }
`

const ShowForMediumUp = styled(Row)`
  display: none;
  ${({ theme: { media } }) =>
    media.medium(css`
      display: block;
    `)};
`

const FooterWithLine = styled(Footer)`
  & > div > div > div:first-child {
    display: none;
  }

  box-shadow: none;
  border-top: 1px solid;
  border-color: ${({ theme }) => theme.colors.neutral.nickel};
  height: auto;
`
const CopyrightFont = styled.p`
  && {
    font-size: 10px;
    letter-spacing: 0.5px;
    line-height: 20px;
    margin-top: ${({ marginTop }) => marginTop || '16px'};
    margin-bottom: ${({ marginBottom }) => marginBottom || '16px'};
    text-align: left;
    color: ${({ theme }) => theme.colors.neutral.silverDollar};
    @media (min-width: 768px) {
      text-align: left;
    }
  }
`

const HoursFont = styled(CopyrightFont)`
  && {
    text-align: left;
    ${({ theme: { media } }) =>
      media.medium(css`
        text-align: right;
      `)};
  }
`

const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.neutral.dime};
`

export const ButtonFooter = styled(Footer)`
  && {
    ${({ theme: { media } }) =>
      media.medium(css`
        background: none;
        box-shadow: none;
        margin-bottom: 5.5rem;
        pointer-events: none;
        z-index: 2;
      `)}

    button {
      pointer-events: auto;
    }

    @media all and (min-width: 768px) and (max-width: 790px) {
      margin-bottom: 8.4375rem;
    }

    @media all and (min-width: 791px) and (max-width: 1170px) {
      margin-bottom: 7.1875rem;
    }
  }
`

export const MobileRelativeFooter = ({ telephone, hours }) => {
  const date = new Date()
  const year = date.getFullYear()

  return (
    <FooterRowMobile className="show-for-mobile">
      <Divider />
      <Col medium={6} small={12}>
        <CopyrightFont marginTop="1.5rem">
          Copyright © {year} The Northwestern Mutual Life Insurance Company. All Rights Reserved. Northwestern Mutual is the marketing name for The
          Northwestern Mutual Life Insurance Company and its subsidiaries.
        </CopyrightFont>
      </Col>
      <Col medium={6} small={12}>
        <HoursFont>Contact Us - {telephone}</HoursFont>
        <HoursFont marginBottom="1.5rem">{hours}</HoursFont>
      </Col>
    </FooterRowMobile>
  )
}

export const StickyDesktopFooter = ({ telephone, hours }) => {
  const date = new Date()
  const year = date.getFullYear()

  return (
    <React.Fragment>
      <ShowForMediumUp className="hide-for-mobile">
        <FooterWithLine>
          <Col medium={6} small={10}>
            <CopyrightFont>
              Copyright © {year} The Northwestern Mutual Life Insurance Company. All Rights Reserved. Northwestern Mutual is the marketing name for
              The Northwestern Mutual Life Insurance Company and its subsidiaries.
            </CopyrightFont>
          </Col>
          <Col medium={6} small={10}>
            <HoursFont marginBottom="0">Contact Us - {telephone}</HoursFont>
            <HoursFont marginTop="0">{hours}</HoursFont>
          </Col>
        </FooterWithLine>
      </ShowForMediumUp>
    </React.Fragment>
  )
}
